/* eslint-disable import/no-extraneous-dependencies */
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import * as shippingInfoActions from '../../actions';
import injectReducer from '../../../../utils/injectReducer';
import injectSaga from '../../../../utils/injectSaga';
import taggingSaga from '../../../Common/Tagging.js/sagas';
import saga from '../../sagas';
import shippingInfo from '../../reducer';
import * as shippingInfoSelectors from '../../selectors/shippingInfoSelectors';
import * as cartActions from '../../../../services/Cart/actions';
import cartSaga from '../../../../services/Cart/sagas';
import * as taggingActions from '../../../Common/Tagging.js/actions';

import { checkPlanReferenceData } from '../../../../utils/plansReference';
import { getZipCode } from '../../../Cart/selectors/cartSelectors';
import ShippingInfoComp from '../../../../components/Web/ShippingInfo/redesign/index';
import { universalProfileBannerDisplayed } from '../../../ContactInfo/actions';

const mapStateToProps = (state) => {
  const shippingInfoSelector = shippingInfoSelectors.selectShippingData(state);
  const shippingInfoState = state.shippingInfo;
  const cartDetails = state.cartDetails || {};
  const currentView = state.currentView || {};
  const marketDetails = state.shippingInfo.marketDetails || {};
  const isbillingInfoEdited = state.contactInfo && state.contactInfo.billingInfoEdited ? state.contactInfo.billingInfoEdited : false;
  const shippingInfoDetails = state.shippingInfo.ShippingInfoDetails || {};
  const loader = state.loader || {};
  const orderDetails = cartDetails?.cartDetailsJson?.orderDetailsView || {};
  const validateOrder = state?.cartDetails?.validateOrder || {}; // getValidateOrder(state.cartDetails);
  const creditStatus = validateOrder?.orderDetails?.[0] || {};
  const isCreditHold = creditStatus && creditStatus.creditApprovalStatus && creditStatus.creditApprovalStatus !== 'AP'; // getCreditHoldStatus(state.cartDetails);
  const isCreditStatusAvailable =
    isCreditHold || validateOrder.downpaymentRequired || (validateOrder.errorMessage && validateOrder.errorMessage !== '');
  const plansReferenceData = checkPlanReferenceData(state.plansReferenceData);
  const creditStatusLanded = state.creditStatus?.creditStatusLanded;
  const isInvalidAddressError = state.shippingInfo && state.shippingInfo.isInvalidAddressError;
  const apiFailureError = state.shippingInfo && state.shippingInfo.apiFailureError;
  const updateShippingAdressResponse = state.shippingInfo?.updateShippingAdressResponse;
  const eidQuestionsFromCreditStatus = state.creditCheckDetails?.creditReviewSuccessResponse?.serviceResponse?.context?.cartInfo?.eidQuestionnaire;
  const openISPUModal = shippingInfoState?.openISPUModal;
  const zipcode = getZipCode(state, isbillingInfoEdited);
  const updateValidateOTPResponse = shippingInfoState?.updateValidateOTPResponse;
  const shippingInvalidCaseError = state.shippingInfo && state.shippingInfo.shippingInvalidError;
  const AUTH_CODE_VERIFICATION_ERROR = state.shippingInfo?.AUTH_CODE_VERIFICATION_ERROR || null;
  const shippingServiceInfo = state.shippingInfo && state.shippingInfo.shippingServiceInfo;
  const shippingInfoError = state.shippingInfo?.shippingInfoError || false;
  const shippingInfoNtfyMsg = state.shippingInfo?.shippingInfoNtfyMsg;
  const cradleResponseDetails = state.SessionValues?.shippingCradleValue;
  const removedWHWPlus= state.shippingInfo?.removedWHWPlus;
  const selectOtherOption = state.shippingInfo?.selectOtherOption;
  const apiLoaded = state.SessionValues?.apiLoaded;
  const selectedExpressCheckout = state.shippingInfo?.selectedExpressCheckout;
  const {
    isUniversalProfileSuccessBannerDisplayed,
    isUniversalProfileCreated,
    universalProfileCreationStatus,
    universalProfileCreationBannerMessages,
  } = state.contactInfo;

  return {
    shippingInfoSelector,
    cradleResponseDetails,
    shippingInfoState,
    cartDetails,
    currentView,
    orderDetails,
    shippingInfoDetails,
    loader,
    removedWHWPlus,
    selectOtherOption,
    selectedExpressCheckout,
    plansReferenceData,
    isCreditStatusAvailable,
    creditStatusLanded,
    isbillingInfoEdited,
    isInvalidAddressError,
    apiFailureError,
    marketDetails,
    updateShippingAdressResponse,
    eidQuestionsFromCreditStatus,
    openISPUModal,
    zipcode,
    updateValidateOTPResponse,
    shippingInvalidCaseError,
    AUTH_CODE_VERIFICATION_ERROR,
    shippingServiceInfo,
    shippingInfoError,
    shippingInfoNtfyMsg,
    isUniversalProfileSuccessBannerDisplayed,
    isUniversalProfileCreated,
    universalProfileCreationStatus,
    universalProfileCreationBannerMessages,
    apiLoaded,
  };
};
function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...shippingInfoActions, ...cartActions, ...taggingActions, universalProfileBannerDisplayed }, dispatch);
}
const withReducer = compose(injectReducer({ key: 'shippingInfo', reducer: shippingInfo }));

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

const withSaga = compose(
  injectSaga({ key: 'shippingInfo', saga }),
  injectSaga({ key: 'cartDetails', saga: cartSaga }),
  injectSaga({ key: 'taggingDetails', saga: taggingSaga }),
);

export default withRouter(
  compose(
    withSaga,
    withReducer,
    withConnect,
  )(ShippingInfoComp),
);
